import * as fromActuals from "./actuals.reducer";
import { IState } from "../reducers";
import { IUnitsViewModel } from "../../common/services/contracts/actuals.contracts";

export const getEntireActuals = (wbsId: string) => (store: IState): fromActuals.IActualsState => store.units[wbsId] ? store.units[wbsId] : fromActuals.initialState;
export const getActuals = (wbsId: string) => (store: IState): IUnitsViewModel[] => getEntireActuals(wbsId)(store).units;
export const getActualsLoading = (wbsId: string) => (store: IState): boolean => getEntireActuals(wbsId)(store).loading;
export const getActualsLoaded = (wbsId: string) => (store: IState): boolean => getEntireActuals(wbsId)(store).loaded;
export const getActualsError = (wbsId: string) => (store: IState): string => getEntireActuals(wbsId)(store).error;
